/**
 * Removes the boot loader overlay from the DOM
 */
export function removeBootLoader(): void {
  try {
    const bootLoader = document.getElementById('app-boot-loader');
    if (bootLoader) {
      bootLoader.style.display = 'none';
      bootLoader.remove();
    }
  } catch (e) {
    // Silently fail if DOM is not available
  }
}

